// Per-page SEO metadata in Norwegian, English, German.
type Tri = { no: string; en: string; de: string };

export const pageMeta: Record<string, { title: Tri; description: Tri }> = {
  home: {
    title: {
      no: "Envir | Gjenvinning av jord og gravemasser i Bergen",
      en: "Envir | Soil & excavation mass recycling in Bergen",
      de: "Envir | Boden- und Aushubmassen-Recycling in Bergen",
    },
    description: {
      no: "Et av verdens mest komplette anlegg for gjenvinning av forurenset jord og gravemasser. Massemottak, salg og laboratorieanalyse i Bergen.",
      en: "One of the world's most complete facilities for recycling contaminated soil and excavation mass. Mass reception, sales and lab analysis in Bergen, Norway.",
      de: "Eine der weltweit vollständigsten Anlagen für das Recycling von kontaminiertem Boden und Aushubmassen. Annahme, Verkauf und Laboranalyse in Bergen.",
    },
  },
  baerekraft: {
    title: {
      no: "Bærekraft og sirkulær økonomi | Envir",
      en: "Sustainability & circular economy | Envir",
      de: "Nachhaltigkeit & Kreislaufwirtschaft | Envir",
    },
    description: {
      no: "Hvordan Envir gjenvinner forurenset jord, kutter CO₂ og støtter FNs bærekraftsmål gjennom sirkulær økonomi.",
      en: "How Envir recycles contaminated soil, cuts CO₂ and supports the UN Sustainable Development Goals.",
      de: "Wie Envir kontaminierten Boden recycelt, CO₂ reduziert und die UN-Nachhaltigkeitsziele unterstützt.",
    },
  },
  laboratorium: {
    title: {
      no: "Laboratorium | Akkreditert jordanalyse i Bergen | Envir",
      en: "Laboratory | Accredited soil analysis in Bergen | Envir",
      de: "Labor | Akkreditierte Bodenanalyse in Bergen | Envir",
    },
    description: {
      no: "Vårt laboratorium på Laksevåg utfører akkrediterte analyser av jord og gravemasser med rask leveringstid.",
      en: "Our laboratory in Laksevåg performs accredited analyses of soil and excavation mass with fast turnaround.",
      de: "Unser Labor in Laksevåg führt akkreditierte Analysen von Boden und Aushubmassen mit kurzen Lieferzeiten durch.",
    },
  },
  jorddampeanlegg: {
    title: {
      no: "Jorddampeanlegg | Termisk rensing av forurenset jord | Envir",
      en: "Soil steaming plant | Thermal treatment of contaminated soil | Envir",
      de: "Bodendampfanlage | Thermische Behandlung von kontaminiertem Boden | Envir",
    },
    description: {
      no: "Industrielt jorddampeanlegg som renser jord med organiske forurensninger gjennom termisk desorpsjon.",
      en: "Industrial soil steaming plant that treats soil with organic contaminants through thermal desorption.",
      de: "Industrielle Bodendampfanlage zur Behandlung von Boden mit organischen Schadstoffen durch thermische Desorption.",
    },
  },
  jordvaskeanlegg: {
    title: {
      no: "Jordvaskeanlegg | Industriell vasking av jord | Envir",
      en: "Soil washing plant | Industrial soil washing | Envir",
      de: "Bodenwaschanlage | Industrielle Bodenwäsche | Envir",
    },
    description: {
      no: "Vårt jordvaskeanlegg separerer og renser forurensede masser slik at de kan gjenbrukes som ren ressurs.",
      en: "Our soil washing plant separates and cleans contaminated masses so they can be reused as clean resources.",
      de: "Unsere Bodenwaschanlage trennt und reinigt kontaminierte Massen, sodass sie als saubere Ressource wiederverwendet werden können.",
    },
  },
  mottak: {
    title: {
      no: "Massemottak | Levering av forurenset jord | Envir",
      en: "Mass reception | Delivery of contaminated soil | Envir",
      de: "Massenannahme | Lieferung von kontaminiertem Boden | Envir",
    },
    description: {
      no: "Slik leverer du forurenset jord og gravemasser til Envir – krav, dokumentasjon og prosess.",
      en: "How to deliver contaminated soil and excavation mass to Envir – requirements, documentation and process.",
      de: "So liefern Sie kontaminierten Boden und Aushubmassen an Envir – Anforderungen, Dokumentation und Prozess.",
    },
  },
  kunnskapssenter: {
    title: {
      no: "Kompetansesenter | Eksperter på jordrensing | Envir",
      en: "Knowledge centre | Soil remediation experts | Envir",
      de: "Wissenszentrum | Experten für Bodensanierung | Envir",
    },
    description: {
      no: "Møt ekspertene i Envir og få faglig veiledning om håndtering av forurenset jord og gravemasser.",
      en: "Meet the experts at Envir and get professional guidance on handling contaminated soil and excavation mass.",
      de: "Treffen Sie die Experten von Envir und erhalten Sie fachliche Beratung zum Umgang mit kontaminiertem Boden.",
    },
  },
  ispsKai: {
    title: {
      no: "ISPS-kai | Sjøtransport av masser i Bergen | Envir",
      en: "ISPS quay | Sea transport of mass in Bergen | Envir",
      de: "ISPS-Kai | Seetransport von Massen in Bergen | Envir",
    },
    description: {
      no: "ISPS-godkjent kai for sikker sjøtransport av forurenset jord og gravemasser til og fra Envir i Bergen.",
      en: "ISPS-certified quay for safe sea transport of contaminated soil and excavation mass to and from Envir in Bergen.",
      de: "ISPS-zertifizierter Kai für den sicheren Seetransport von kontaminiertem Boden und Aushubmassen.",
    },
  },
  salgsbetingelser: {
    title: {
      no: "Salgsbetingelser | Envir",
      en: "Terms of sale | Envir",
      de: "Verkaufsbedingungen | Envir",
    },
    description: {
      no: "Salgsbetingelser for produkter og tjenester levert av Envir AS.",
      en: "Terms of sale for products and services delivered by Envir AS.",
      de: "Verkaufsbedingungen für Produkte und Dienstleistungen von Envir AS.",
    },
  },
  team: {
    title: {
      no: "Mennesker | Vårt team | Envir",
      en: "People | Our team | Envir",
      de: "Menschen | Unser Team | Envir",
    },
    description: {
      no: "Bli kjent med menneskene i Envir – eksperter på gjenvinning av forurenset jord og gravemasser.",
      en: "Meet the people of Envir – experts in recycling contaminated soil and excavation mass.",
      de: "Lernen Sie die Menschen von Envir kennen – Experten für das Recycling kontaminierter Böden.",
    },
  },
  gjenvunneMasser: {
    title: {
      no: "Gjenvunne masser | Rene produkter til gjenbruk | Envir",
      en: "Reclaimed mass | Clean products for reuse | Envir",
      de: "Wiederverwertete Massen | Saubere Produkte zur Wiederverwendung | Envir",
    },
    description: {
      no: "Kjøp rensede, gjenvunne masser fra Envir – bærekraftige alternativer til jomfruelige byggematerialer.",
      en: "Buy clean, reclaimed mass from Envir – sustainable alternatives to virgin construction materials.",
      de: "Kaufen Sie saubere, wiederverwertete Massen von Envir – nachhaltige Alternativen zu Primärbaustoffen.",
    },
  },
  priskalkulator: {
    title: {
      no: "Priskalkulator | Estimer levering av masser | Envir",
      en: "Price calculator | Estimate mass delivery | Envir",
      de: "Preisrechner | Lieferung von Massen schätzen | Envir",
    },
    description: {
      no: "Beregn estimert pris for levering av forurenset jord og gravemasser til Envir.",
      en: "Estimate the cost of delivering contaminated soil and excavation mass to Envir.",
      de: "Schätzen Sie die Kosten für die Lieferung von kontaminiertem Boden und Aushubmassen an Envir.",
    },
  },
  omOss: {
    title: {
      no: "Om oss | Envir AS – gjenvinning av jord i Bergen",
      en: "About us | Envir AS – soil recycling in Bergen",
      de: "Über uns | Envir AS – Bodenrecycling in Bergen",
    },
    description: {
      no: "Envir er en norsk miljøbedrift som gjenvinner forurenset jord og gravemasser. Les historien vår.",
      en: "Envir is a Norwegian environmental company recycling contaminated soil and excavation mass. Read our story.",
      de: "Envir ist ein norwegisches Umweltunternehmen, das kontaminierten Boden und Aushubmassen recycelt.",
    },
  },
  nyheter: {
    title: {
      no: "Nyheter & innsikt | Envir",
      en: "News & insight | Envir",
      de: "Neuigkeiten & Einblicke | Envir",
    },
    description: {
      no: "Siste nytt, prosjekter og fagartikler om gjenvinning av forurenset jord fra Envir.",
      en: "Latest news, projects and articles on contaminated soil recycling from Envir.",
      de: "Aktuelle Neuigkeiten, Projekte und Fachartikel zum Recycling kontaminierter Böden von Envir.",
    },
  },
  kontakt: {
    title: {
      no: "Kontakt oss | Envir AS",
      en: "Contact us | Envir AS",
      de: "Kontakt | Envir AS",
    },
    description: {
      no: "Ta kontakt med Envir – salg, mottak, laboratorium og generelle henvendelser.",
      en: "Get in touch with Envir – sales, mass reception, laboratory and general enquiries.",
      de: "Kontaktieren Sie Envir – Verkauf, Annahme, Labor und allgemeine Anfragen.",
    },
  },
  vaartStyre: {
    title: {
      no: "Vårt styre | Envir AS",
      en: "Our board | Envir AS",
      de: "Unser Vorstand | Envir AS",
    },
    description: {
      no: "Møt styret og daglig leder i Envir AS.",
      en: "Meet the board and managing director of Envir AS.",
      de: "Lernen Sie den Vorstand und den Geschäftsführer von Envir AS kennen.",
    },
  },
  notFound: {
    title: {
      no: "Siden finnes ikke | Envir",
      en: "Page not found | Envir",
      de: "Seite nicht gefunden | Envir",
    },
    description: {
      no: "Vi finner ikke siden du leter etter.",
      en: "We can't find the page you're looking for.",
      de: "Wir können die gesuchte Seite nicht finden.",
    },
  },
};
